import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Filter from '../../Filter';
import Table from '../../Table';
import Pagination from '../../TablePagination';
import LimitButton from '../../LimitSelectBox';
import doorlockLogFormatter from './DoorlockLogFormatter';

const DoorlockLogList = ({
  doorlockLogListTotal,
  doorlockLogListItems,
  filterItem,
  sortItem,
  paginationItem,
  setFilterItem,
  setSortItem,
  setPaginationItem,
  inDetailPage,
  history,
}) => {
  const { t } = useTranslation();
  const [ currentPageNumber, setCurrentPageNumber ] = useState(1);

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const changeLimit = (limit) => {
    setCurrentPageNumber(1);
    setPaginationItem({
      offset: 0,
      limit,
    });
  };

  const changeSort = (sort) => {
    if (sortItem.sort === sort) {
      setSortItem({
        ...sortItem,
        order: sortItem.order === 'desc' ? 'asc':'desc',
      });
    } else {
      setSortItem({
        sort,
        order: 'desc',
      });
    }
  };

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    setFilterItem({
      ...filterItem,
      ...targetItem,
    }, debounce);
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const initFilterItem = () => {
    setFilterItem({
      logType: '',
    });
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  return (
    <Fragment>
      <div className={`content-title ${inDetailPage ? 'detail':''}`}>
        <Filter
          columns={[
            {
              key: 'logType',
              type: 'select',
              placeholder: t('placeholder.type'),
              value: filterItem.logType,
              action: changeFilterItem,
              selectItems: doorlockLogFormatter.logFormatterTypeList,
              selectItemKey: 'text',
              selectItemValue: 'value',
              isRemoveButton: true,
            },
          ]}
          init={initFilterItem}
        />
      </div>
      <Table
        columns={[
          {
            key: 'log_id',
            text: t('data_column.log_id'),
            width: '8%',
            sort: {
              func: changeSort,
              params: 'log_id',
              selected: sortItem.sort === 'log_id',
              order: sortItem.sort === 'log_id' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'log_type',
            text: t('data_column.type'),
            width: '14%',
            formatter: {
              func: doorlockLogFormatter.formatType,
              params: ['log_type'],
            },
          },
          {
            key: 'log_message',
            text: t('data_column.message'),
            width: '54%',
            formatter: {
              func: doorlockLogFormatter.formatMessage,
              params: ['log_type', 'log_message'],
            },
          },
          {
            key: 'log_event_date',
            text: t('data_column.evented_at'),
            width: '12%',
            formatter: {
              func: doorlockLogFormatter.formatTime,
              params: ['log_event_date'],
            },
            sort: {
              func: changeSort,
              params: 'log_event_date',
              selected: sortItem.sort === 'log_event_date',
              order: sortItem.sort === 'log_event_date' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'created_at',
            text: t('data_column.created_at'),
            width: '12%',
            formatter: {
              func: doorlockLogFormatter.formatTime,
              params: ['created_at'],
            },
            sort: {
              func: changeSort,
              params: 'created_at',
              selected: sortItem.sort === 'created_at',
              order: sortItem.sort === 'created_at' ? sortItem.order : 'desc',
            },
          },
        ]}
        datas={doorlockLogListItems}
      />
      <LimitButton
        currentLimit={paginationItem.limit}
        changeLimit={changeLimit}
      />
      <Pagination
        total={doorlockLogListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
    </Fragment>
  );
};

export default DoorlockLogList;